import {createBrowserHistory} from 'history'

// This is here instead of in Router to prevent cyclical dependency errors
export const history = createBrowserHistory()
